













import Vue from 'vue';
import OfficesTable from '@/components/Offices/OfficesTable.vue';
import OfficesMap from '@/components/Offices/OfficesMap.vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
    components: {
        OfficesTable,
        OfficesMap,
    },
    data() {
        return {
            selectedStops: [] as Array<object>,
            search: '',
        };
    },
    methods: {
        ...mapActions('offices', ['getOffices']),
        onOfficeSelected(row: any) {
            this.selectedStops = [row];
        },
    },
    computed: {
        ...mapState('offices', ['corpOffices']),
    },
    created() {
        this.getOffices();
    },
});
